import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './ui/views/Dashboard.vue'),
    },
    {
      path: '/area/:id',
      name: 'dashboard-area-detail',
      component: () => import(/* webpackChunkName: "dashboard" */ './ui/views/Dashboard.vue'),
    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './ui/views/EventOverview.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import(/* webpackChunkName: "settings" */ './ui/views/Settings.vue'),
    },
    {
      path: '/tv',
      name: 'tv',
      component: () => import(/* webpackChunkName: "settings" */ './ui/views/Dashboard.vue'),
      props: { tvMode: true },
    },
  ],
});
